// Module
var code = `<template class="ag-price-editor">
  <require from="./agPriceEditor.scss"></require>
  <input ref="inputElement" focus.bind="hasFocus" value.bind="value">
</template>
`;
// Exports
export default code;